import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import serializeForm from 'form-serialize';
import FormError from '../../components/form-error/FormError';
import BorderBox from '../../components/BorderBox';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import Main from '../../frame/main/Main';
import ButtonText from '../../components/button/button-text/ButtonText';
import { ContentTitle } from '../../components/typography/Heading';
import Input2 from '../../components/input/input-2/Input2';
import SmallWidthContainer from '../../components/small-width-container/SmallWidthContainer';
import RoundedButtonPrimary from '../../components/button/rounded-button-primary/RoundedButtonPrimary';
import HoofdTitle from '../../components/HoofdTitle';
import { getUser } from '../user-selectors';
import { redirect, useNavigate } from 'react-router';
import { fetchAuthenticatedUser, resetPassword } from '../user-actions';

import styles from './reset-password.module.less';

const ResetPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const resetPasswordState = useSelector((state) => state.resetPassword);

    const errors = resetPasswordState.errors || {};
    const success = resetPasswordState.success;

    const forgotPasswordClick = (e) => {
        e.preventDefault();
        const state = serializeForm(e.target, { hash: true });
        dispatch(resetPassword(state));
    };

    useEffect(() => {
        trackPageView({ urlAsEvent: 'reset-password' });
    }, []);

    const handleCancel = () => {
        navigate('/login');
    };

    if (success) {
        return (
            <Main>
                <SmallWidthContainer>
                    <BorderBox className={styles.borderBox}>
                        <ContentTitle>{success.global}</ContentTitle>
                    </BorderBox>
                </SmallWidthContainer>
            </Main>
        );
    }

    return (
        <Main>
            <SmallWidthContainer>
                <HoofdTitle title="Glemt passord" />
                <BorderBox className={styles.borderBox}>
                    <form onSubmit={(e) => forgotPasswordClick(e)}>
                        <ContentTitle tag="h1">Glemt passord</ContentTitle>
                        <FormError error={errors.global} />

                        <div className="input-group">
                            <Input2
                                title="E-post"
                                type="email"
                                autoComplete="email"
                                fieldName="email"
                                required
                                error={errors.email}
                            />
                        </div>
                        <RoundedButtonPrimary type="submit">Fortsett</RoundedButtonPrimary>
                    </form>
                    <ButtonText className={styles.cancelButton} onClick={(e) => handleCancel(e)}>
                        Avbryt
                    </ButtonText>
                </BorderBox>
            </SmallWidthContainer>
        </Main>
    );
};

export default ResetPassword;

export const loader = async ({ getState, dispatch }) => {
    await dispatch(fetchAuthenticatedUser());
    const user = getUser(getState());
    if (user.token) {
        return redirect('/me');
    }
};
